export default __webpack_public_path__ + "assets/bb318a5d51ba72aa94b9fdba184a6a62.ttf";